import React from "react";
import { connect } from "react-redux";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Table,
  Input,
  Badge,
  Pagination,
  PaginationItem,
  PaginationLink
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import moment from "moment";
import api from "./../../../Api.js";
import CertificateViewer from "./CertificateViewer.jsx";
import SimpleHeader from "./../../../components/Headers/SimpleHeader.jsx";

class CertificatesAdmin extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      certificates: [],
      total: 0,
      limit: 20,
      offset: 0,
      search: '',
      loading: true,
      selected: null,
      showViewer: false
    };
    this.searchTimeout = null;
  }

  componentDidMount() {
    this.loadCertificates();
  }

  async loadCertificates() {
    this.setState({ loading: true });
    try {
      var res = await api.getAllCertificatesAdmin({
        limit: this.state.limit,
        offset: this.state.offset,
        search: this.state.search
      });
      this.setState({
        certificates: (res.data && res.data.data) || [],
        total: (res.data && res.data.total) || 0,
        loading: false
      });
    } catch (err) {
      this.notify('danger', 'Erro', 'Falha ao carregar certificados');
      this.setState({ loading: false });
    }
  }

  notify(type, title, message) {
    try {
      this.refs.notificationAlert.notificationAlert({
        place: 'tr',
        message: (
          <div className="alert-text">
            <span className="alert-title">{title}</span>
            <span> {message}</span>
          </div>
        ),
        type: type,
        icon: 'ni ni-bell-55',
        autoDismiss: 6
      });
    } catch (e) {}
  }

  handleSearch(value) {
    this.setState({ search: value, offset: 0 });
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => this.loadCertificates(), 500);
  }

  changePage(offset) {
    this.setState({ offset: offset }, () => this.loadCertificates());
  }

  openViewer(cert) {
    this.setState({ selected: cert, showViewer: true });
  }

  closeViewer() {
    this.setState({ selected: null, showViewer: false });
  }

  async deleteCertificate(cert) {
    if (!window.confirm('Revogar/deletar o certificado ' + cert.certificateCode + '? Esta ação não pode ser desfeita.')) {
      return;
    }
    try {
      await api.deleteCertificate(cert.id);
      this.notify('success', 'Removido', 'Certificado revogado');
      this.loadCertificates();
    } catch (err) {
      this.notify('danger', 'Erro', 'Falha ao revogar');
    }
  }

  exportCSV() {
    var rows = [['Código', 'Aluno', 'Curso', 'Turma', 'Nível', 'Horas', 'Média', 'Data']];
    this.state.certificates.forEach(function (c) {
      rows.push([
        c.certificateCode,
        (c.userName || '') + ' ' + (c.userLastName || ''),
        c.courseName || '',
        c.classroomName || '',
        c.skillLevel || '',
        c.totalHours || 0,
        c.averageScore || 0,
        moment(c.completionDate).format('DD/MM/YYYY')
      ]);
    });
    var csv = rows.map(function (r) {
      return r.map(function (cell) {
        return '"' + String(cell).replace(/"/g, '""') + '"';
      }).join(',');
    }).join('\n');
    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = 'certificados-' + moment().format('YYYY-MM-DD') + '.csv';
    link.click();
    URL.revokeObjectURL(url);
  }

  getSkillColor(level) {
    var colors = {
      'Avançado': 'success',
      'Intermediário': 'warning',
      'Iniciante': 'info'
    };
    return colors[level] || 'secondary';
  }

  render() {

    var permissions = this.props.permission || [];
    if (permissions.indexOf(21) === -1 && permissions.indexOf(26) === -1) {
      return (
        <Container className="mt--7" fluid>
          <Card>
            <CardBody>
              <p className="text-center text-muted">Acesso restrito ao administrador.</p>
            </CardBody>
          </Card>
        </Container>
      );
    }

    var totalPages = Math.ceil(this.state.total / this.state.limit);
    var currentPage = Math.floor(this.state.offset / this.state.limit);

    var translate = this.props.translate || {};

    return (
      <React.Fragment>
        <div className="rna-wrapper"><NotificationAlert ref="notificationAlert" /></div>
        <SimpleHeader
          name={translate.certificados_emitidos || "Certificados Emitidos"}
          way={[{name: translate.gestao_conquistas || "Gestão de Conquistas", url: "/admin/certificates"}]}
          buttons={<React.Fragment></React.Fragment>}
        />
        <Container className="mt--6" fluid>
          <Row>
            <Col xl="12">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col>
                      <h3 className="mb-0">
                        <i className="fas fa-graduation-cap text-danger mr-2" />
                        Certificados Emitidos
                        <Badge color="danger" pill className="ml-2">{this.state.total}</Badge>
                      </h3>
                    </Col>
                    <Col xs="auto">
                      <Button color="success" size="sm" onClick={() => this.exportCSV()}>
                        <i className="fas fa-file-csv mr-1" />
                        Exportar CSV
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col md="6">
                      <Input
                        type="text"
                        placeholder="Buscar por código, aluno ou turma..."
                        value={this.state.search}
                        onChange={(e) => this.handleSearch(e.target.value)}
                      />
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {this.state.loading ? (
                    <div className="text-center py-4">
                      <i className="fas fa-spinner fa-spin fa-2x text-muted" />
                    </div>
                  ) : this.state.certificates.length === 0 ? (
                    <div className="text-center py-4 text-muted">
                      <i className="fas fa-inbox fa-3x mb-2" style={{ opacity: 0.3 }} />
                      <p>Nenhum certificado encontrado.</p>
                    </div>
                  ) : (
                    <Table hover responsive>
                      <thead className="thead-light">
                        <tr>
                          <th>Código</th>
                          <th>Aluno</th>
                          <th>Curso / Turma</th>
                          <th>Nível</th>
                          <th>Horas</th>
                          <th>Média</th>
                          <th>Data</th>
                          <th style={{ width: '150px' }}>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.certificates.map((c) => (
                          <tr key={c.id}>
                            <td><code style={{ fontSize: '0.75rem' }}>{c.certificateCode}</code></td>
                            <td>
                              <strong>{c.userName} {c.userLastName}</strong>
                              {c.username && <div><small className="text-muted">@{c.username}</small></div>}
                            </td>
                            <td>
                              <div>{c.courseName || '-'}</div>
                              {c.classroomName && <small className="text-muted">{c.classroomName}</small>}
                            </td>
                            <td>
                              <Badge color={this.getSkillColor(c.skillLevel)} pill>
                                {c.skillLevel || 'Iniciante'}
                              </Badge>
                            </td>
                            <td>{parseFloat(c.totalHours || 0).toFixed(0)}h</td>
                            <td>{parseFloat(c.averageScore || 0).toFixed(1)}</td>
                            <td><small>{moment(c.completionDate).format('DD/MM/YYYY')}</small></td>
                            <td>
                              <Button color="link" size="sm" onClick={() => this.openViewer(c)} title="Visualizar">
                                <i className="fas fa-eye text-primary" />
                              </Button>
                              <Button
                                color="link"
                                size="sm"
                                onClick={() => window.open('/certificate/verify/' + c.certificateCode, '_blank')}
                                title="Link público"
                              >
                                <i className="fas fa-link text-info" />
                              </Button>
                              <Button color="link" size="sm" onClick={() => this.deleteCertificate(c)} title="Revogar">
                                <i className="fas fa-trash text-danger" />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}

                  {/* Paginação */}
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-3">
                      <Pagination>
                        <PaginationItem disabled={currentPage === 0}>
                          <PaginationLink onClick={() => this.changePage(Math.max(0, this.state.offset - this.state.limit))}>
                            <i className="fas fa-chevron-left" />
                          </PaginationLink>
                        </PaginationItem>
                        <PaginationItem active>
                          <PaginationLink>
                            {currentPage + 1} / {totalPages}
                          </PaginationLink>
                        </PaginationItem>
                        <PaginationItem disabled={currentPage >= totalPages - 1}>
                          <PaginationLink onClick={() => this.changePage(this.state.offset + this.state.limit)}>
                            <i className="fas fa-chevron-right" />
                          </PaginationLink>
                        </PaginationItem>
                      </Pagination>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {this.state.showViewer && this.state.selected && (
          <CertificateViewer
            certificate={this.state.selected}
            userName={this.state.selected.userName + ' ' + (this.state.selected.userLastName || '')}
            onClose={() => this.closeViewer()}
          />
        )}
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  permission: state.permission,
  user: state.user,
  translate: state.translate
}))(CertificatesAdmin);
